import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useContext } from "react";
import Context from "../../../context";

function setInfoFromStatus(account) {
  if (account.invoice){
    return {
      ShutOff: {
        mainText: "Shut Off \n Scheduled",
        subText: "$" + account?.invoice?.balanceRemaining.toFixed(2) + " Shut Off",
      },
      PastDue: {
        mainText: "Past \n Due",
        subText: "$" + account?.invoice?.balanceRemaining.toFixed(2) + " Past Due",
      },
      Due: {
        mainText: "$" + account?.invoice?.balanceRemaining.toFixed(2),
        subText: "Due " + dayjs(account.dueDate).format("MMM D, YYYY"),
      },
      DueSoon: {
        mainText: "$" + account?.invoice?.balanceRemaining.toFixed(2),
        subText: "Due " + dayjs(account.dueDate).format("MMM D, YYYY"),
      },
      Paid: {
        mainText: "Paid",
        subText:
            "$" +
            account?.invoice?.balanceDue?.toFixed(2) +
            " Paid on " +
            dayjs(account?.invoice?.datePaid).format("MMM D, YYYY"),
      },
    };
  }
  else{
    return {
      none: {
        mainText: "",
        subText: "",
      },
    };
  }
}

function AccountDueDetail({ payload }) {
  return (
    <div className="due-detail">
      <h2 className="due-detail-main-text">{payload?.mainText}</h2>
      <p className="due-detail-sub-text">{payload?.subText}</p>
    </div>
  );
}

export default function AccountItem({ account }) {
  const { contextState, setContextState } = useContext(Context);

  function getAccountObject(id) {
    return contextState.accounts.find((acct) => {
      return acct.customerNumber === id;
    });
  }

  function setActiveAccount(id) {
    setContextState({
      ...contextState,
      currentAccountId: id,
      currentAccount: getAccountObject(id),
    });
  }

  return (
    <li className={`account-item ${account.status}`}>
      <div className="business-info">
        <h5 className="business-name">{account.customerName}</h5>
        <small className="customer-number">
          Customer #: {account.customerNumber}
        </small>
      </div>
      <small className="customer-number">{account.customerAddress}</small>
      <AccountDueDetail payload={setInfoFromStatus(account)[account.status]} />

      <Link
        className="view-account-link"
        to={"/account/" + account.customerNumber + "/detail"}
        onClick={() => {
          setActiveAccount(account.customerNumber);
        }}>
        View Account
      </Link>
    </li>
  );
}
